import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import Senai from '@assets/icons/senai';
import Lab365 from '@assets/icons/lab365';
import InstagramLogo from '@assets/icons/instagram-logo';
import LinkedInLogo from '@assets/icons/linkedin-logo';
import { User } from '@redux/prop-types';
import { userSelector } from '@redux/selectors';
import { useUserAccess } from '@utils/hooks/use-user-access';

import './footer.css';
import { useLocation } from '@reach/router';

const CADASTRO_SCTEC_ROUTE = '/cadastro-sctec/';

interface FooterProps {
  user?: User;
}

const mapStateToProps = createSelector(userSelector, (user: User) => ({
  user
}));

function Footer({ user }: FooterProps): JSX.Element {
  const { t } = useTranslation();
  const { isSCTEC } = useUserAccess(user ?? ({} as User));
  const location = useLocation();

  if (isSCTEC || location.pathname === CADASTRO_SCTEC_ROUTE) {
    return <></>;
  }

  return (
    <footer className='site-footer'>
      <div className='footer-row'>
        <div className='footer-logo'>
          <Senai />
          <Lab365 />
        </div>
        <div className='footer-social-media'>
          <p>{t('footer.follow-us')}</p>
          <a
            href='https://www.instagram.com/lab365_/'
            target='_blank'
            rel='noreferrer'
          >
            <InstagramLogo />
          </a>
          <a
            href='https://www.linkedin.com/company/lab365/'
            target='_blank'
            rel='noreferrer'
          >
            <LinkedInLogo />
          </a>
        </div>
      </div>
    </footer>
  );
}

Footer.displayName = 'Footer';
export default connect(mapStateToProps)(Footer);
